
import React, { useState } from 'react';


/// SingleReply =>
/// 댓글 수정/삭제/답글 선택 팝업
export default props=>{
	// console.log("props: ", props);
	const [d, setd] = useState('none');

	function isAvailable(){
		return (
			// 로그인했고 & (로긴자가 이사람 | 로긴자가 관리자) 면, 수정/삭제
			typeof localStorage != 'undefined' && typeof localStorage["loginer"] != 'undefined')
				&& props.me.user && props.me.user.id
				&& (props.me.user.id == JSON.parse(localStorage["loginer"]).id
					//  || (JSON.parse(localStorage["loginer"]).is_admin) // 수정삭제가 다된다는말은, 관리자로 로그인했기때문인것 같다.
		);
	}

const jsx=(<div className="" >
<style jsx>{`

.arrow_box {
	/* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12); */
	border: solid 1px #dee2e6;
	background-color: #ffffff;

	font-size: 14px;
	color: #343a40;
}

span{
	float: left;
}


.item{
	width: 300px;
	height: 55px;
	padding: 15px;
	text-align:center;
	margin: 0 auto;

}

`}</style>

	<div className="arrow_box" onClick={props.hide}>

		{isAvailable() ? <>
			<div className="item mouse-aa" onClick={props.onSelectAmend}>댓글 수정</div>
			<div className="horizon-bar" />
			<div className="item mouse-aa" onClick={props.onSelectDelete}>댓글 삭제</div>
			<div className="horizon-bar" />
		</>: null}
		<div className="item mouse-aa" onClick={props.onSelectRERE}>답글</div>
	</div>

</div>);
	return (jsx);
}

